module.exports = __webpack_public_path__ + "static/us_fish_friendly-0a1a7e545951512ff4c426d2d8aa1f04.png";